// Sterowanie klawiaturą/pedałem Bluetooth (Faza: dostęp bez dotykania
// ekranu). Gitarzysta z podłączoną klawiaturą albo pedałem BLE (który dla
// systemu wygląda jak klawiatura) steruje grą bez odrywania rąk od gitary.
//
// Nasłuch jest JEDEN, wpięty na `document` na czas życia aplikacji (patrz
// wywołanie w `main.ts`), a nie doczepiany przy każdym renderze widoku gry -
// `pokazUtwor()` przebudowuje `#tresc` przy każdej zmianie utworu i dublowałby
// nasłuchy, gdyby podpinać je tam. Sam handler czyta AKTUALNY widok z
// `#app[data-widok]` przy każdym naciśnięciu, więc nie potrzebuje odświeżania.
//
// Klawisze rozpoznawane po `event.code` (fizyczny klawisz), nie `event.key`
// (znak): `KeyM` w tabeli wymagań to nazwa kodu, nie litery "m"/"M", a `Space`
// jako kod jest jednoznaczny niezależnie od układu klawiatury.

export interface SterowaineOpcje {
  onNastepnaSekcja: () => void;
  onPoprzedniaSekcja: () => void;
  onNastepnyUtwor: () => void;
  onPoprzedniUtwor: () => void;
  onMenu: () => void;
  onMikrofon: () => void;
}

const KODY_NASTEPNEJ_SEKCJI = new Set(['ArrowRight', 'PageDown', 'Space']);
const KODY_POPRZEDNIEJ_SEKCJI = new Set(['ArrowLeft', 'PageUp']);

/** Czy `widok` to KTÓRYKOLWIEK z widoków gry (`granie` albo `granie-tekst`). */
function czyWidokGrania(widok: string | null | undefined): boolean {
  return (widok ?? '').startsWith('granie');
}

/**
 * Podpina nasłuch klawiatury/pedału na `document`. Aktywny wyłącznie w
 * widoku gry (`#app[data-widok]` zaczynające się od `granie`), poza nim
 * naciśnięcia mają przejść dalej bez `preventDefault()` (np. pisanie w
 * formularzu wklejania utworu).
 *
 * Zwraca funkcję sprzątającą, która zdejmuje nasłuch.
 */
export function podepnijSterowanie(opcje: SterowaineOpcje): () => void {
  const obsluzKlawisz = (zdarzenie: KeyboardEvent): void => {
    const app = document.querySelector<HTMLElement>('#app');
    if (!czyWidokGrania(app?.getAttribute('data-widok'))) return;

    const kod = zdarzenie.code;

    if (KODY_NASTEPNEJ_SEKCJI.has(kod)) {
      zdarzenie.preventDefault();
      opcje.onNastepnaSekcja();
    } else if (KODY_POPRZEDNIEJ_SEKCJI.has(kod)) {
      zdarzenie.preventDefault();
      opcje.onPoprzedniaSekcja();
    } else if (kod === 'ArrowDown') {
      zdarzenie.preventDefault();
      opcje.onNastepnyUtwor();
    } else if (kod === 'ArrowUp') {
      zdarzenie.preventDefault();
      opcje.onPoprzedniUtwor();
    } else if (kod === 'Escape') {
      zdarzenie.preventDefault();
      opcje.onMenu();
    } else if (kod === 'KeyM') {
      zdarzenie.preventDefault();
      opcje.onMikrofon();
    }
  };

  document.addEventListener('keydown', obsluzKlawisz);
  return () => document.removeEventListener('keydown', obsluzKlawisz);
}
